import * as React from 'react';
import { Translate } from '../../../shared/LanguageService';
import { IPhotoOrderListItem } from '../Entities';
import * as Site from '../../../shared/Site';
import { Link } from 'react-router-dom';
import * as PhotoStatus from '../../../shared/PhotoStatus';
import ProductPropertiesIcons from '../../propertyIcons/ProductPropertiesIcons';
import OrderStatusesIcons from '../../statusicons/StatusIcons';
import OrderListTableCell from '../../../components/common/OrderListTableCell';
import AssignUser from '../AssignUser';
import * as Features from '../../../shared/Features';
import * as ProductProperty from '../../../shared/ProductProperties';
import moment from 'moment';

interface PhotoOrderListRowProps {
    key: number;
    order: IPhotoOrderListItem;
    user: any;
}

const PhotoOrderListRow = (props: PhotoOrderListRowProps) => {
    const canViewOrder = Features.hasFeature(Features.ViewOrder, props.user);
    const orderLink = `/orders/${props.order.orderId}/image`;

    let rowClass = Site.getOrderCssClass(props.order.site);

    const productsToExclude = [ProductProperty.BlueSky];

    if (props.order.isExpress) {
        rowClass += ' express';
    } else if (props.order.isExpressWeekend) {
        rowClass += ' express-weekend';
    } else if (props.order.isEarlyDelivery) {
        rowClass += ' early-delivery';
    }

    if (props.order.orderStatus === PhotoStatus.DeliveryError) {
        rowClass = rowClass + ' delivery-error';
    }

    if (props.order.isOldEditOrder) {
        rowClass = rowClass + ' old-edit-order';
    }

    return (
        <tr className={rowClass} data-testid="order-row">
            <td>
                <Link to={`/ordercollections/${props.order.orderCollectionId}`}>
                    {props.order.orderCollectionNumber}
                </Link>
                :{props.order.orderNumber}
            </td>
            <OrderListTableCell clickable={canViewOrder} navigateTo={orderLink}>
                {props.order.brokerFirmName}
            </OrderListTableCell>
            <OrderListTableCell clickable={canViewOrder} navigateTo={orderLink}>
                {props.order.packageProduct}
            </OrderListTableCell>
            <OrderListTableCell clickable={canViewOrder} navigateTo={orderLink}>
                {props.order.photographerName}
            </OrderListTableCell>
            <OrderListTableCell clickable={canViewOrder} navigateTo={orderLink}>
                {Translate(props.order.orderStatusTranslation)}
            </OrderListTableCell>
            <OrderListTableCell clickable={canViewOrder} navigateTo={orderLink}>
                {props.order.numberOfImages}
            </OrderListTableCell>
            <OrderListTableCell clickable={canViewOrder} navigateTo={orderLink} className="nobreak">
                {props.order.deadline && moment(props.order.deadline).format('L LT')}
            </OrderListTableCell>
            <OrderListTableCell clickable={canViewOrder} navigateTo={orderLink} className="nobreak">
                {props.order.completedTime && moment(props.order.completedTime).format('L LT')}
            </OrderListTableCell>
            {props.order.assignedUserName && (
                <OrderListTableCell clickable={canViewOrder} navigateTo={orderLink}>
                    {props.order.assignedUserName}
                </OrderListTableCell>
            )}
            {!props.order.assignedUserName && (
                <td>
                    <AssignUser user={props.user} orderId={props.order.orderId} />
                </td>
            )}
            <OrderListTableCell clickable={canViewOrder} navigateTo={orderLink}>
                <ProductPropertiesIcons
                    properties={props.order.productProperties.filter((property) => {
                        return property.value !== productsToExclude.find((x) => x === property.value);
                    })}
                ></ProductPropertiesIcons>
            </OrderListTableCell>
            <OrderListTableCell clickable={canViewOrder} navigateTo={orderLink}>
                <OrderStatusesIcons
                    orderStatuses={props.order.orderStatuses}
                    isOldEditOrder={props.order.isOldEditOrder}
                ></OrderStatusesIcons>
            </OrderListTableCell>
        </tr>
    );
};

export default PhotoOrderListRow;
